<template>
  <div>
    <v-data-table
      show-expand
      :expanded.sync="expanded"
      :headers="headers"
      :items="documentos.content"
      class="elevation-0 rounded-card"
      :loading="loading"
      :server-items-length="documentos.total"
      no-data-text="Nenhum Documento encontrado"
      loading-text="Carregando Documentos..."
      hide-default-footer
    >
      <template v-slot:item.titulo="{ item }">
        {{ item.titulo }}
      </template>
      <template v-slot:item.dataInicio="{ item }">
        {{ item.dataInicio | date | naoInformado }}
      </template>
      <template v-slot:item.dataLimite="{ item }">
        {{ item.dataLimite | date | naoInformado }}
      </template>
      <template v-slot:item.options="{ item }">
        <px-download-file :file="item.arquivo"
                                  download-base-path="files/download-comprador"/>
        <px-fornecedor-edit-documento
              v-if="hasRoleComprador"
              :documento-prop="item"
              :fornecedor="fornecedor"
              @update="onUpdate">
              <template v-slot:activator="{ on }">
                <v-btn icon v-on="on">
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>
              </template>
        </px-fornecedor-edit-documento>
        <v-btn icon @click="onRemove(item)" v-if="hasRoleComprador">
            <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
      <template v-slot:expanded-item="{ item }">
        <td :colspan="headers.length">
          <px-lista-documentos-detalhes :documento="item" />
        </td>
      </template>
    </v-data-table>
    <px-confirm-dialog ref="confirm" />
  </div>
</template>

<script>
import DocumentoService from '../../../gestao-fornecedor-service';
import FornecedorEditDocumento from '../../edicao/FornecedorEditDocumento.vue';
import ListaDocumentosDetalhes from './ListaDocumentosDetalhes.vue';

export default {
  props: {
    hasRoleComprador: Boolean,
    documentos: Object,
    fornecedor: Object,
    default: [],
    loading: Boolean,
  },
  data() {
    return {
      expanded: [],
      headers: [
        {
          text: 'Titulo',
          sortable: false,
          value: 'titulo',
        },
        {
          text: 'Data de Inicio',
          sortable: false,
          value: 'dataInicio',
        },
        {
          text: 'Data de Vencimento',
          sortable: false,
          value: 'dataLimite',
        },
        {
          text: null,
          sortable: false,
          value: 'options',
          align: 'right',
        },
        {
          text: '',
          align: 'start',
          value: 'data-table-expand',
        },
      ],
    };
  },
  methods: {
    remove(item) {
      this.loading = true;
      DocumentoService.removeDocumento(this.fornecedor.id, item.id)
        .then(() => {
          this.$toast('Documento removido', { color: 'success' });
          this.getDocumentos();
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onRemove(item) {
      this.$refs.confirm.open('Você deseja remover o documento?',
        'O documento será removido e não poderá ser recuperado',
        { width: 300 })
        .then((confirm) => {
          if (!confirm) {
            return;
          }
          this.remove(item);
        });
    },
    getDocumentos() {
      this.loading = true;
      DocumentoService.getDocumentos(this.fornecedor.id)
        .then((response) => {
          this.documentos = response.data || [];
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onUpdate() {
      this.$emit('update');
      this.getDocumentos();
    },
  },
  components: {
    pxFornecedorEditDocumento: FornecedorEditDocumento,
    pxListaDocumentosDetalhes: ListaDocumentosDetalhes,
  },
};
</script>
